<template>
    <div :id="ID_BASE + informacion.idElemento">
      <!-- FORMATO CARRUSEL DE IMAGNES -->
      <CCarruselImagenes v-if="formatosDeSeccion.some(f => f.tipoDeFormato == enumeraciones.TiposFormatoIntranet.CarruselSimple)" 
            :imagenes="CARRUSEL.imagenes"
            :opciones="CARRUSEL.opciones"></CCarruselImagenes>
      <!-- FORMATO TARJETAS DE ENLACES -->
      <CCardEnlaces v-if="formatosDeSeccion.some(f => f.tipoDeFormato == enumeraciones.TiposFormatoIntranet.TarjetaDeEnlaces)" 
          :idContenedor="1"
          :tarjetas="TARJETAS_ENLACES.tarjetas"
          :opciones="TARJETAS_ENLACES.opciones"></CCardEnlaces>
      <!-- FORMATO CONTENEDOR DE ENLACES -->
      <CContenedorEnlaces v-if="formatosDeSeccion.some(f => f.tipoDeFormato == enumeraciones.TiposFormatoIntranet.ContenedorDeEnlaces)" 
          :idContenedor="2"
          :enlaces="CONTENEDOR_ENLACES.enlaces"
          :opciones="CONTENEDOR_ENLACES.opciones"></CContenedorEnlaces>
       <!-- FORMATO LISTADO DE DOCUMENTOS -->
       <CListaDeDocumentos v-if="formatosDeSeccion.some(f => f.tipoDeFormato == enumeraciones.TiposFormatoIntranet.ListadoDeDocumentosArea)" 
          :idContenedor="2"
          :documentos="DOCUMENTOS.lista"
          :opciones="DOCUMENTOS.opciones"></CListaDeDocumentos>
        <!-- FORMATO FORMULARIO ENVIO DE EDICTOS -->
        <CFormularioEnvioEdictos v-if="formatosDeSeccion.some(f => f.tipoDeFormato == enumeraciones.TiposFormatoIntranet.FormularioEnvioEdictos)" 
          v-on:enviar="enviarEdicto"
          :opciones="DOCUMENTOS.opciones"></CFormularioEnvioEdictos>
        <!-- FORMATO CONTENEDOR DE MATERIAL -->
        <CContenedorMaterial v-if="formatosDeSeccion.some(f => f.tipoDeFormato == enumeraciones.TiposFormatoIntranet.ContenedorMaterialArea)" 
            :materiales="CONTENEDOR_MATERIAL.materiales"
            :opciones="CONTENEDOR_MATERIAL.opciones"></CContenedorMaterial>
        <!-- FORMATO TARJETA DE SESIONES -->
       <CCardSesion v-if="formatosDeSeccion.some(f => f.tipoDeFormato == enumeraciones.TiposFormatoIntranet.TarjetaSesiones)" 
          :idContenedor="6"
          :sesiones="TARJETAS_SESIONES.sesiones"
          :opciones="TARJETAS_SESIONES.opciones"></CCardSesion>
        <!-- FORMATO CONTENEDOR DE CONVOCATORIAS -->
       <CContenedorConvocatorias v-if="formatosDeSeccion.some(f => f.tipoDeFormato == enumeraciones.TiposFormatoIntranet.ContenedorDeConvocatorias)" 
          :idContenedor="6"
          :convocatorias="CONTENEDOR_CONVOCATORIAS.convocatorias"
          :opciones="CONTENEDOR_CONVOCATORIAS.opciones"></CContenedorConvocatorias>
        <!-- FORMATO CARRUSEL DE IMAGNES -->
        <CComunicados v-if="formatosDeSeccion.some(f => f.tipoDeFormato == enumeraciones.TiposFormatoIntranet.CarruselNoticias)" 
            :noticias="CARRUSEL_NOTICIAS.noticias"
            :opciones="CARRUSEL_NOTICIAS.opciones"></CComunicados>
        <!-- LISTADO DE NOTICICAS -->
        <CTablaGenerica v-if="formatosDeSeccion.some(f => f.tipoDeFormato == enumeraciones.TiposFormatoIntranet.TablaComunicados)" 
            :elementos="LISTADO_NOTICIAS.elementos"
            :opciones="LISTADO_NOTICIAS.opciones"></CTablaGenerica>
    </div>
</template>
<script>
import CCarruselImagenes from "@/components/Intranet/Formatos/CCarruselImagenes.vue";
import CCardEnlaces from "@/components/Intranet/Formatos/CCardEnlaces.vue";
import CContenedorEnlaces from "@/components/Intranet/Formatos/CContenedorEnlaces.vue";
import CListaDeDocumentos from "@/components/Intranet/Formatos/CListaDeDocumentos.vue";
import enumeraciones from '@/../static/js/enumeraciones/sicpo.js'
import CFormularioEnvioEdictos from "@/components/Intranet/Formatos/CFormularioEnvioEdictos.vue";
import CContenedorMaterial from "@/components/Intranet/Formatos/CContenedorMaterial.vue";
import CCardSesion from "@/components/Intranet/Formatos/CCardSesion.vue";
import CContenedorConvocatorias from "@/components/Intranet/Formatos/CContenedorConvocatorias.vue";
import CComunicados from "@/components/Intranet/Formatos/CComunicados.vue";
import CTablaGenerica from "@/components/Intranet/Formatos/CTablaGenerica.vue";

export default {
    name: 'seccion',
    props: {
        informacion: {
            type: Object,
            default: () => ({ idElemento: 0, nombre: 'seccion'})
        },
        formatosDeSeccion: {
            type: Array,
            default: () => [
                { tipoDeFormato: -1, contenidos: [] }
            ]
        },
        opciones: {
            type: Object,
            default: () => ({ 
                tiposDocumentoArea: [],
                formularioEdictos: {},
                carrusel: null,
                ListadoDeDocumentos: null,
                tipoDeDocumentoSeleccionado: null,
                esClinica: false,
                menuDeUsuario: []
            })
        },
    },
    components: {
        CCarruselImagenes: CCarruselImagenes,
        CCardEnlaces: CCardEnlaces,
        CContenedorEnlaces: CContenedorEnlaces,
        CListaDeDocumentos: CListaDeDocumentos,
        CFormularioEnvioEdictos: CFormularioEnvioEdictos,
        CContenedorMaterial: CContenedorMaterial,
        CCardSesion: CCardSesion,
        CContenedorConvocatorias: CContenedorConvocatorias,
        CComunicados: CComunicados,
        CTablaGenerica: CTablaGenerica
    },
    data() {
        return {
            enumeraciones,
            ID_BASE: 'seccion-intranet',
            // formato Carrusel
            CARRUSEL: {
                imagenes: [],
                opciones: {
                    conFondo: false,
                    conTituloCarrusel: { mostrar: true, texto: 'Avisos', estilosCss: 'color: #000000; font-weight: bold;' },
                    conTitulo: { mostrar: false, identificador: 'Titulo' }, // remplazar por propiedades reales del objeto de contenido de la entidad
                    conImagen: { mostrar: true, identificador: 'RutaDeAcceso' }, // remplazar por propiedades reales del objeto de contenido de la entidad
                    conDescripcion: { mostrar: false, identificador: 'Descripcion' }, // remplazar por propiedades reales del objeto de contenido de la entidad
                    configuraciones: { 
                        autoPlay: true,
                        dimensiones: { 
                            0: { items: true, nav: false }, 
                            600:{ items: true, nav: false },
                            800: { items: true, nav: false },
                            1200: { items: true, nav: false }
                        },
                        estilosCss: 'height: 30em; border-radius: 10px 10px 10px 10px;'
                    } 
                }
            },
            //formato tarjeta de enlaces
            TARJETAS_ENLACES: {
                tarjetas: [],
                opciones: {
                    conTitulo: { mostrar: true, texto: 'Titulo', estilosCss: '' },
                    tarjetasPorFila: 4,
                    centrarTarjetas: true,
                    menuDeUsuario: ''
                }
            },
            // formato contenedor de enlaces
            CONTENEDOR_ENLACES: {
                enlaces: [],
                opciones: {
                    conTitulo: { mostrar: true, texto: 'Enlaces', estilosCss: 'font-weight: bold;' }
                }
            },
            // formato contenedor de enlaces
            DOCUMENTOS: {
                lista: [],
                opciones: {
                    paddingDefault: { aplicar: true, css: '' },
                    filtrosBusqueda: { mostrar: true },
                    titulo: { mostrar: true, nombre: 'Documentos' },
                    tiposDeDocumentos: []
                }
            },
            // formato para formulario envio de edictos
            FORMULARIO_EDICTOS: {
                opciones: { 
                    conEstilosDefault: { mostrar: true, estiloCssNuevo: '' }
                }
            },
            // formato para materiales de area
            CONTENEDOR_MATERIAL: {
                materiales: [],
                opciones: {
                    conEstilosDefault: { mostrar: true, css: 'padding: 4vmin 0 0 0;' }
                }
            },
            // formato para tarjetas de sesiones
            TARJETAS_SESIONES: {
                sesiones: [],
                opciones: {
                }
            },
            // formato contenedor de convocatorias
            CONTENEDOR_CONVOCATORIAS: {
                convocatorias: [],
                opciones: {
                    conTitulo: { mostrar: true, texto: 'Convocatorias', estilosCss: 'font-weight: bold;' }
                }
            },
            // formato Carrusel NOTICIAS
            CARRUSEL_NOTICIAS: {
                noticias: [],
                opciones: {
                    configuraciones: { 
                        autoPlay: true,
                        dimensiones: { 
                            0: { items: 1, nav: false }, 
                            600:{ items: 1, nav: false },
                            800: { items: 1, nav: false },
                            1200: { items: 1, nav: false }
                        },
                        estilosCss: 'height: 35em;'
                    } 
                }
            },
            LISTADO_NOTICIAS: {
                elementos: [],
                opciones: {}
            }
        }
    },
    methods: {
        enviarEdicto: function(datos) {
            this.$emit('enviarEdicto',datos);
        },
        darFormatoContenidoCarrusel: async function(formato) {
            if(this.campoRequeridoEsValido(this.opciones.carrusel)) {
                this.CARRUSEL.opciones = this.opciones.carrusel.opciones;
            } 

            if(this.campoRequeridoEsValido(formato) && formato.hasOwnProperty('contenidos')) {
                /* this.CARRUSEL.imagenes = formato.contenidos.map(c => {
                    let imgFormateada = {};
                    imgFormateada.Titulo = c.Titulo;
                    imgFormateada.RutaDeAcceso = c.RutaDeAcceso;
                    imgFormateada.Descripcion = c.Descripcion;
                    return imgFormateada;
                }); */
                this.CARRUSEL.imagenes = formato.contenidos;
            }
        },
        darFormatoContenidoTarjetaEnlaces: async function(formato) {
            this.TARJETAS_ENLACES.opciones.conTitulo.texto = this.informacion.nombre;
            this.TARJETAS_ENLACES.opciones.menuDeUsuario = this.opciones.menuDeUsuario;
            if(this.campoRequeridoEsValido(formato) && formato.hasOwnProperty('contenidos')) {
                this.TARJETAS_ENLACES.tarjetas = formato.contenidos.map(c => {
                    return c;
                });
            }
        },
        darFormatoContenidoContenedorEnlaces: async function(formato) {
            if(this.campoRequeridoEsValido(formato) && formato.hasOwnProperty('contenidos')) {
                this.CONTENEDOR_ENLACES.enlaces = formato.contenidos.map(c => {
                    return c;
                });
            }
        },
        darFormatoContenidoDocumentosArea: async function(formato) { 
            this.DOCUMENTOS.opciones = (this. campoRequeridoEsValido(this.opciones.ListadoDeDocumentos)) 
                ? this.opciones.ListadoDeDocumentos.opciones : this.DOCUMENTOS.opciones;
            this.DOCUMENTOS.opciones.tipoDeDocumentoSeleccionado = this.opciones.tipoDeDocumentoSeleccionado;

            this.DOCUMENTOS.opciones.esClinica = this.opciones.esClinica;

            if(this.campoRequeridoEsValido(formato) && formato.hasOwnProperty('contenidos')) {
                this.DOCUMENTOS.opciones.tiposDeDocumentos = this.opciones.tiposDocumentoArea;
                console.log('his.DOCUMENTOS.opciones::', this.DOCUMENTOS.opciones);
                this.DOCUMENTOS.lista = formato.contenidos.map(c => {
                    return c;
                });
            }
        },
        obtenerConfiguracionFormularioEdictos: async function(formato) {
            if(this.campoRequeridoEsValido(formato) && this.campoRequeridoEsValido(this.opciones.formularioEdictos)) {
                this.FORMULARIO_EDICTOS.opciones = (this.campoRequeridoEsValido(this.opciones.formularioEdictos.opciones))
                    ? this.opciones.formularioEdictos.opciones
                    : this.FORMULARIO_EDICTOS.opciones;
            }
        },
        darFormatoContenidoMaterialesArea: async function(formato) {
            if(this.campoRequeridoEsValido(formato) && formato.hasOwnProperty('contenidos')) {
                this.CONTENEDOR_MATERIAL.materiales = formato.contenidos.map(c => {
                    return c;
                });
            }
        },
        darFormatoContenidoTarjetasSesiones: async function(formato) { debugger
            if(this.campoRequeridoEsValido(formato) && formato.hasOwnProperty('contenidos')) {
                this.TARJETAS_SESIONES.sesiones = formato.contenidos.map(c => {
                    return c;
                });
            }
            console.log('formato::',formato);
            console.log('this.TARJETAS_SESIONES.sesiones::',this.TARJETAS_SESIONES.sesiones);
        },
        darFormatoContenidoConvocatorias: async function(formato) { debugger
            if(this.campoRequeridoEsValido(formato) && formato.hasOwnProperty('contenidos')) {
                this.CONTENEDOR_CONVOCATORIAS.convocatorias = formato.contenidos.map(c => {
                    return c;
                });
            }
        },
        darFormatoContenidoCarruselNoticias: async function(formato) { debugger
            if(this.campoRequeridoEsValido(formato) && formato.hasOwnProperty('contenidos')) {
                /* this.CARRUSEL_NOTICIAS.noticias = formato.contenidos.map(c => {
                    let noticiaFormateada = {};
                    noticiaFormateada.id = c.id;
                    noticiaFormateada.Titulo = c.Titulo;
                    noticiaFormateada.RutaDeAcceso = c.RutaDeAcceso;
                    noticiaFormateada.Descripcion = c.Descripcion;
                    noticiaFormateada.Fecha = c.Fecha;
                    return noticiaFormateada;
                }); */
                this.CARRUSEL_NOTICIAS.noticias = formato.contenidos;
            }
        },
        darFormatoListadoNoticias: async function(formato) {
            if(this.campoRequeridoEsValido(formato) && formato.hasOwnProperty('contenidos')) {
                this.LISTADO_NOTICIAS.elementos = formato.contenidos.map(c => {
                    return c;
                });
            }
        },
        campoRequeridoEsValido: function(campo) { 
            let esValido = false
            if(typeof campo === 'string' || campo instanceof String) {
                // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
                if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'number' || campo instanceof Number) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo > 0) {
                    esValido = true;
                }
            }
            else {
                if (campo != null && campo != undefined) {
                    esValido = true;
                }
            }
            return esValido;
        }
    },
    async mounted() {
        const FORMATO_CARRUSEL = this.formatosDeSeccion.find(f => f.tipoDeFormato == enumeraciones.TiposFormatoIntranet.CarruselSimple);
        const FORMATO_TARJETAS_ENLACES = this.formatosDeSeccion.find(f => f.tipoDeFormato == enumeraciones.TiposFormatoIntranet.TarjetaDeEnlaces);
        const FORMATO_CONTENEDOR_ENLACES = this.formatosDeSeccion.find(f => f.tipoDeFormato == enumeraciones.TiposFormatoIntranet.ContenedorDeEnlaces);
        const FORMATO_DOCUMENTOS_AREAS = this.formatosDeSeccion.find(f => f.tipoDeFormato == enumeraciones.TiposFormatoIntranet.ListadoDeDocumentosArea);
        const FORMATO_FORMULARIO_EDICTOS = this.formatosDeSeccion.find(f => f.tipoDeFormato == enumeraciones.TiposFormatoIntranet.FormularioEnvioEdictos);
        const FORMATO_CONTENEDOR_MATERIALES = this.formatosDeSeccion.find(f => f.tipoDeFormato == enumeraciones.TiposFormatoIntranet.ContenedorMaterialArea);
        const FORMATO_TARJETAS_SESIONES = this.formatosDeSeccion.find(f => f.tipoDeFormato == enumeraciones.TiposFormatoIntranet.TarjetaSesiones);
        const FORMATO_CONTENEDOR_CONVOCATORIAS = this.formatosDeSeccion.find(f => f.tipoDeFormato == enumeraciones.TiposFormatoIntranet.ContenedorDeConvocatorias);
        const FORMATO_CARRUSEL_NOTICIAS = this.formatosDeSeccion.find(f => f.tipoDeFormato == enumeraciones.TiposFormatoIntranet.CarruselNoticias);
        const FORMATO_LISTADO_NOTICIAS = this.formatosDeSeccion.find(f => f.tipoDeFormato == enumeraciones.TiposFormatoIntranet.TablaComunicados);
        await Promise.resolve(this.darFormatoListadoNoticias(FORMATO_LISTADO_NOTICIAS));
        await Promise.resolve(this.darFormatoContenidoCarrusel(FORMATO_CARRUSEL));
        await Promise.resolve(this.darFormatoContenidoTarjetaEnlaces(FORMATO_TARJETAS_ENLACES));
        await Promise.resolve(this.darFormatoContenidoContenedorEnlaces(FORMATO_CONTENEDOR_ENLACES));
        await Promise.resolve(this.darFormatoContenidoDocumentosArea(FORMATO_DOCUMENTOS_AREAS));
        await Promise.resolve(this.obtenerConfiguracionFormularioEdictos(FORMATO_FORMULARIO_EDICTOS));
        await Promise.resolve(this.darFormatoContenidoMaterialesArea(FORMATO_CONTENEDOR_MATERIALES));
        await Promise.resolve(this.darFormatoContenidoTarjetasSesiones(FORMATO_TARJETAS_SESIONES));
        await Promise.resolve(this.darFormatoContenidoConvocatorias(FORMATO_CONTENEDOR_CONVOCATORIAS));
        await Promise.resolve(this.darFormatoContenidoCarruselNoticias(FORMATO_CARRUSEL_NOTICIAS));
    },
}
</script>
<style scoped>

#contenedor-seccion-principal-intarnet {
    background-color: #FFFFFF;
    min-height: calc(100vh - 103px);
    color: #111;
}
</style>


// WEBPACK FOOTER //
// src/components/Intranet/Comun/CSeccion.vue